// import React from 'react';
// import { Container, Row, Col, Button, Card } from 'react-bootstrap';
// import { Link, useNavigate } from 'react-router-dom';
// import { FiDollarSign, FiPieChart, FiTrendingUp, FiBox, FiCreditCard } from 'react-icons/fi';
// import { FaWhatsapp } from 'react-icons/fa';
// import { useAuth } from '../context/AuthContext';

// const Homepage = () => {
//   const { user } = useAuth();
//   const navigate = useNavigate();

//   return (
//     <>
//       {/* Hero: The Struggle */}
//       <Container className="text-center py-5">
//         <h1 className="display-4 fw-bold">
//           Struggling to Manage Inventory & Sales?
//         </h1>
//         <p className="lead text-muted mb-4">
//           You’re not alone. Countless small business owners lose profits due to manual tracking and scattered records.
//           But what if you had a smarter way?
//         </p>
//         <Button
//           variant="success"
//           size="lg"
//           onClick={() => navigate(user ? "/dashboard" : "/auth")}
//         >
//           {user ? "Go to Dashboard" : "Start Your Journey"}
//         </Button>
//       </Container>

//       {/* Features: The Solution */}
//       <Container className="py-5">
//         <h2 className="text-center mb-4">Meet Your New Business Partner</h2>
//         <p className="text-center text-muted mb-4">
//           We designed this system for MSMEs like yours—built with simplicity, speed, and smart insights to help you thrive.
//         </p>
//         <Row className="g-4">
//           <FeatureCard
//             icon={<FiBox size={28} />}
//             title="Smart Inventory Management"
//             description="Real-time stock tracking with automatic value calculation and low-stock alerts."
//           />
//           <FeatureCard
//             icon={<FiTrendingUp size={28} />}
//             title="Sales Analytics"
//             description="Detailed insights into top-selling products and daily performance metrics."
//           />
//           <FeatureCard
//             icon={<FiCreditCard size={28} />}
//             title="Credit Management"
//             description="Track customer credits and payment histories with smart reminders."
//           />
//           <FeatureCard
//             icon={<FiPieChart size={28} />}
//             title="Profit & Credit Insights"
//             description="Monitor profits, view credit balances, and get guidance to grow your business."
//           />
//         </Row>
//       </Container>

//       {/* Insights: The Transformation */}
//       <Container className="py-5 bg-light">
//         <h2 className="text-center mb-4">See the Change in Action</h2>
//         <p className="text-center text-muted mb-4">
//           Our clients are already unlocking growth with smarter decisions. Here’s a glimpse of what you’ll see:
//         </p>
//         <Card className="p-4 shadow-sm">
//           <Row className="mb-4">
//             <MetricCard title="Total Inventory Value" value="Ksh 61,944" icon={<FiBox />} bg="teal" />
//             <MetricCard title="Potential Revenue" value="Ksh 87,350" icon={<FiDollarSign />} bg="purple" />
//           </Row>
//           <Row className="mb-4">
//             <MetricCard title="Today’s Net Profit" value="Ksh 4,870" icon={<FiTrendingUp />} bg="success" />
//             <MetricCard title="Outstanding Credits" value="Ksh 12,000" icon={<FiCreditCard />} bg="danger" />
//           </Row>
//           <Card body className="mt-3">
//             <h5>Sales Overview (Daily)</h5>
//             <div className="d-flex justify-content-between align-items-center">
//               <span><span className="badge bg-success me-2">&nbsp;</span> Completed Sales</span>
//               <span className="fw-semibold text-success">Ksh 17,530</span>
//             </div>
//           </Card>
//         </Card>
//         <p className="text-center text-muted mt-4">
//           Want to <strong>visualize these insights using charts</strong> or integrate real-time data? <br />
//           <Link to="/auth" className="btn btn-outline-success mt-2">Request a Demo</Link>
//         </p>
//       </Container>

//       {/* Steps: The Plan */}
//       <Container className="py-5">
//         <h2 className="text-center mb-4">Here’s How You’ll Get There</h2>
//         <p className="text-center text-muted mb-4">
//           In just a few steps, you’ll go from chaos to clarity. No complex training, just results.
//         </p>
//         <Row className="text-center">
//           {['Register and Login', 'Add Stock', 'Record Sales', 'Record Expenses', 'See Reports'].map((step, index) => (
//             <Col key={index} md={2} className="mb-3">
//               <div className="p-3 border rounded shadow-sm h-100">
//                 <h6 className="fw-bold">Step {index + 1}</h6>
//                 <p className="text-muted small mb-0">{step}</p>
//               </div>
//             </Col>
//           ))}
//         </Row>
//       </Container>

//       {/* Contact: Help Along the Way */}
//       <Container className="py-5 bg-light">
//         <h2 className="text-center mb-4">Talk to a Real Person</h2>
//         <p className="text-center">
//           Whether you want a walkthrough or need a custom setup, we’re here for you.
//         </p>
//         <Row className="text-center">
//           {[
//             { number: '+254707615635', message: 'Hi, I would like to request a quotation and demo for your inventory system.' },
//             { number: '+254711280760', message: 'Hello, I am interested in a live demo of your inventory management software.' },
//             { number: '+254714726968', message: 'Greetings, can I get a quotation and walkthrough of the system?' },
//           ].map(({ number, message }, index) => (
//             <Col key={index} md={4} className="mb-3">
//               <a
//                 href={`https://wa.me/${number.replace('+', '')}?text=${encodeURIComponent(message)}`}
//                 className="btn btn-success d-flex align-items-center justify-content-center"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <FaWhatsapp className="me-2" /> WhatsApp {number}
//               </a>
//             </Col>
//           ))}
//         </Row>
//       </Container>

//       {/* Footer: Closing Note */}
//       <footer className="bg-dark text-white py-5 mt-5">
//         <Container className="text-center">
//           <h5>You’re One Step Away from Simpler, Smarter Business</h5>
//           <Button variant="light" className="mt-3" as={Link} to="/auth">
//             Begin Your Free Trial
//           </Button>
//           <hr className="my-4 border-light" />
//           <p className="text-muted small mb-0">© 2024 FinTrack. All rights reserved.</p>
//         </Container>
//       </footer>
//     </>
//   );
// };

// const FeatureCard = ({ icon, title, description }) => (
//   <Col md={3}>
//     <Card className="h-100 shadow-sm border-0">
//       <Card.Body>
//         <div className="text-success mb-3">{icon}</div>
//         <Card.Title>{title}</Card.Title>
//         <Card.Text className="text-muted">{description}</Card.Text>
//       </Card.Body>
//     </Card>
//   </Col>
// );

// const MetricCard = ({ title, value, icon, bg }) => (
//   <Col md={6}>
//     <Card className={`bg-${bg}-100 border-0 rounded shadow-sm p-3 mb-3`}>
//       <div className="d-flex justify-content-between align-items-center">
//         <div>
//           <div className="text-muted small">{title}</div>
//           <div className="fs-4 fw-bold">{value}</div>
//         </div>
//         <div className={`fs-2 text-${bg}`}>{icon}</div>
//       </div>
//     </Card>
//   </Col>
// );

// export default Homepage;

// import React from 'react';
// import { Container, Row, Col, Button, Card } from 'react-bootstrap';
// import { Link, useNavigate } from 'react-router-dom';
// import {
//   FiDollarSign,
//   FiPieChart,
//   FiTrendingUp,
//   FiBox,
//   FiCreditCard
// } from 'react-icons/fi';
// import { FaWhatsapp } from 'react-icons/fa';
// import { useAuth } from '../context/AuthContext';

// const Homepage = () => {
//   const { user } = useAuth();
//   const navigate = useNavigate();

//   return (
//     <>
//       {/* Hero Section */}
//       <Container className="text-center py-5">
//         <h1 className="display-4 fw-bold">
//           Tired of Losing Track of Sales and Stock?
//         </h1>
//         <p className="lead text-muted mb-4">
//           Manual record-keeping is holding your business back. It’s time for a modern solution.
//         </p>
//         <Button
//           variant="success"
//           size="lg"
//           onClick={() => navigate(user ? "/dashboard" : "/auth")}
//         >
//           {user ? "Go to Dashboard" : "Start Free Trial"}
//         </Button>
//       </Container>

//       {/* Features Section */}
//       <Container className="py-5">
//         <h2 className="text-center mb-4">What Can This System Do for You?</h2>
//         <p className="text-center text-muted mb-4">
//           Powerful features designed specifically for small businesses and MSMEs.
//         </p>
//         <Row className="g-4">
//           <FeatureCard
//             icon={<FiBox size={28} />}
//             title="Inventory Management"
//             description="Easily add and track stock. Get alerts for low inventory, auto-calculate values, and view product lists."
//           />
//           <FeatureCard
//             icon={<FiTrendingUp size={28} />}
//             title="Sales Tracking & Receipts"
//             description="Record sales, track top-selling items, and instantly generate PDF and JPEG receipts for customers."
//           />
//           <FeatureCard
//             icon={<FiCreditCard size={28} />}
//             title="Credit Management"
//             description="Keep track of customers who owe you. View credit balances, history, and send reminders."
//           />
//           <FeatureCard
//             icon={<FiPieChart size={28} />}
//             title="Smart Analytics"
//             description="View daily, weekly, and monthly performance – from gross sales to net profit and payment method distribution."
//           />
//         </Row>
//       </Container>

//       {/* Insights Section */}
//       <Container className="py-5 bg-light">
//         <h2 className="text-center mb-4">Your Business, Transformed</h2>
//         <p className="text-center text-muted mb-4">
//           Get instant insights that help you make smarter decisions every day.
//         </p>
//         <Card className="p-4 shadow-sm">
//           <Row className="mb-4">
//             <MetricCard title="Inventory Value" value="Ksh 61,944" icon={<FiBox />} bg="info" />
//             <MetricCard title="Potential Revenue" value="Ksh 87,350" icon={<FiDollarSign />} bg="primary" />
//           </Row>
//           <Row className="mb-4">
//             <MetricCard title="Today’s Net Profit" value="Ksh 4,870" icon={<FiTrendingUp />} bg="success" />
//             <MetricCard title="Outstanding Credit" value="Ksh 12,000" icon={<FiCreditCard />} bg="danger" />
//           </Row>
//           <Card body className="mt-3">
//             <h5>Sales Snapshot (Today)</h5>
//             <div className="d-flex justify-content-between align-items-center">
//               <span><span className="badge bg-success me-2">&nbsp;</span> Completed Sales</span>
//               <span className="fw-semibold text-success">Ksh 17,530</span>
//             </div>
//           </Card>
//         </Card>
//         <p className="text-center text-muted mt-4">
//           Want visual charts and real-time reports?
//           <br />
//           <Link to="/auth" className="btn btn-outline-success mt-2">Request a Demo</Link>
//         </p>
//       </Container>

//       {/* Steps Section */}
//       <Container className="py-5">
//         <h2 className="text-center mb-4">How It Works</h2>
//         <p className="text-center text-muted mb-4">
//           Go from confusion to clarity in five simple steps.
//         </p>
//         <Row className="text-center justify-content-center">
//           {['Register & Login', 'Add Your Stock', 'Record a Sale', 'Track Expenses', 'View Reports & Profits'].map((step, index) => (
//             <Col key={index} xs={6} md={2} className="mb-3">
//               <div className="p-3 border rounded shadow-sm h-100">
//                 <h6 className="fw-bold">Step {index + 1}</h6>
//                 <p className="text-muted small mb-0">{step}</p>
//               </div>
//             </Col>
//           ))}
//         </Row>
//       </Container>

//       {/* Contact Section */}
//       <Container className="py-5 bg-light">
//         <h2 className="text-center mb-4">Talk to a Real Human</h2>
//         <p className="text-center mb-4">
//           Need help? Ask for a live demo or request a personalized setup.
//         </p>
//         <Row className="text-center">
//           {[
//             { number: '+254707615635', message: 'Hi, I would like to request a quotation and demo for your inventory system.' },
//             { number: '+254711280760', message: 'Hello, I am interested in a live demo of your inventory management software.' },
//             { number: '+254714726968', message: 'Greetings, can I get a quotation and walkthrough of the system?' },
//           ].map(({ number, message }, index) => (
//             <Col key={index} md={4} className="mb-3">
//               <a
//                 href={`https://wa.me/${number.replace('+', '')}?text=${encodeURIComponent(message)}`}
//                 className="btn btn-success d-flex align-items-center justify-content-center"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <FaWhatsapp className="me-2" /> WhatsApp {number}
//               </a>
//             </Col>
//           ))}
//         </Row>
//       </Container>

//       {/* Footer Section */}
//       <footer className="bg-dark text-white py-5 mt-5">
//         <Container className="text-center">
//           <h5>You’re One Click Away From a Smarter Business</h5>
//           <Button variant="light" className="mt-3" as={Link} to="/auth">
//             Begin Free Trial
//           </Button>
//           <hr className="my-4 border-light" />
//           <p className="text-muted small mb-0">© 2024 FinTrack. All rights reserved.</p>
//         </Container>
//       </footer>
//     </>
//   );
// };

// const FeatureCard = ({ icon, title, description }) => (
//   <Col md={3}>
//     <Card className="h-100 shadow-sm border-0">
//       <Card.Body>
//         <div className="text-success mb-3">{icon}</div>
//         <Card.Title>{title}</Card.Title>
//         <Card.Text className="text-muted">{description}</Card.Text>
//       </Card.Body>
//     </Card>
//   </Col>
// );

// const MetricCard = ({ title, value, icon, bg }) => (
//   <Col md={6}>
//     <Card className={`bg-${bg}-100 border-0 rounded shadow-sm p-3 mb-3`}>
//       <div className="d-flex justify-content-between align-items-center">
//         <div>
//           <div className="text-muted small">{title}</div>
//           <div className="fs-4 fw-bold">{value}</div>
//         </div>
//         <div className={`fs-2 text-${bg}`}>{icon}</div>
//       </div>
//     </Card>
//   </Col>
// );

// export default Homepage;


import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import {
  FiDollarSign,
  FiPieChart,
  FiTrendingUp,
  FiBox,
  FiCreditCard
} from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';

const Homepage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <>
      {/* Hero Section */}
      <Container className="text-center py-5">
        <h1 className="display-4 fw-bold">"I was drowning in manual calculations with notebooks, a pen, and constant guesswork..."</h1>
        <p className="lead text-muted mb-4">
          Just like you, I was running a small shop, scribbling sales in a notebook, losing stock overnight, and wondering where my money went.
          That’s why we built this system – to give small business owners clarity, control, and peace of mind.
        </p>
        <Button
          variant="success"
          size="lg"
          onClick={() => navigate(user ? "/dashboard" : "/auth")}
        >
          {user ? "Go to Dashboard" : "Start Free Trial – It’s Risk-Free"}
        </Button>
      </Container>

      {/* Features Section */}
      <Container className="py-5">
        <h2 className="text-center mb-4">What Can This System Do for You?</h2>
        <p className="text-center text-muted mb-4">
          Powerful features designed specifically for small businesses and MSMEs.
        </p>
        <Row className="g-4">
          <FeatureCard
            icon={<FiBox size={28} />}
            title="Inventory Management"
            description="Easily add and track stock. Get alerts for low inventory, auto-calculate values, and view product lists."
          />
          <FeatureCard
            icon={<FiTrendingUp size={28} />}
            title="Sales Tracking & Receipts"
            description="Record sales, track top-selling items, and instantly generate PDF and JPEG receipts for customers."
          />
          <FeatureCard
            icon={<FiCreditCard size={28} />}
            title="Credit Management"
            description="Keep track of customers who owe you. View credit balances, history, and send reminders."
          />
          <FeatureCard
            icon={<FiPieChart size={28} />}
            title="Smart Analytics"
            description="View daily, weekly, and monthly performance – from gross sales to net profit and payment method distribution."
          />
        </Row>
      </Container>

      <Container className="py-5">
  <Row className="align-items-center">
    <Col md={6} className="mb-4 mb-md-0">
      <h2 className="fw-bold">Meet Sarah, a Grocery Shop Owner in Nakuru</h2>
      <p className="text-muted">
        Sarah used to spend hours every night reconciling her sales and counting stock manually.
        Her records didn’t match. She lost thousands to untracked credit and theft.
      </p>
      <p className="text-muted">
        Now, with our system, Sarah knows exactly what’s in stock, how much profit she made today,
        and which customers owe her. She says:
      </p>
      <blockquote className="blockquote fst-italic">
        “It feels like I finally have control of my business. I sleep better now.”
      </blockquote>
      <Button variant="outline-success" onClick={() => navigate("/auth")}>
        I Want That Too
      </Button>
    </Col>
    <Col md={6}>
      <div className="h-100 d-flex justify-content-center align-items-center">
        <img
          src="/sara.jpeg"
          alt="Shop owner smiling"
          className="img-fluid rounded shadow"
          style={{ maxHeight: '400px', objectFit: 'cover', width: '100%' }}
        />
      </div>
    </Col>
  </Row>
</Container>

      {/* Insights Section */}
      <Container className="py-5 bg-light">
        <h2 className="text-center mb-4">Your Business, Transformed</h2>
        <p className="text-center text-muted mb-4">
          Get instant insights that help you make smarter decisions every day.
        </p>
        <Card className="p-4 shadow-sm">
          <Row className="mb-4">
            <MetricCard title="Inventory Value" value="Ksh 61,944" icon={<FiBox />} bg="info" />
            <MetricCard title="Potential Revenue" value="Ksh 87,350" icon={<FiDollarSign />} bg="primary" />
          </Row>
          <Row className="mb-4">
            <MetricCard title="Today’s Net Profit" value="Ksh 4,870" icon={<FiTrendingUp />} bg="success" />
            <MetricCard title="Outstanding Credit" value="Ksh 12,000" icon={<FiCreditCard />} bg="danger" />
          </Row>
          <Card body className="mt-3">
            <h5>Sales Snapshot (Today)</h5>
            <div className="d-flex justify-content-between align-items-center">
              <span><span className="badge bg-success me-2">&nbsp;</span> Completed Sales</span>
              <span className="fw-semibold text-success">Ksh 17,530</span>
            </div>
          </Card>
        </Card>
        <p className="text-center text-muted mt-4">
          Want visual charts and real-time reports?
          <br />
          <Link to="/auth" className="btn btn-outline-success mt-2">Request a Demo</Link>
        </p>
      </Container>

      {/* Steps Section */}
      <Container className="py-5">
        <h2 className="text-center mb-4">How It Works</h2>
        <p className="text-center text-muted mb-4">
          Go from confusion to clarity in five simple steps.
        </p>
        <Row className="text-center justify-content-center">
          {['Register & Login', 'Add Your Stock', 'Record a Sale', 'Track Expenses', 'View Reports & Profits'].map((step, index) => (
            <Col key={index} xs={6} md={2} className="mb-3">
              <div className="p-3 border rounded shadow-sm h-100">
                <h6 className="fw-bold">Step {index + 1}</h6>
                <p className="text-muted small mb-0">{step}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Contact Section */}
      <Container className="py-5 bg-light">
        <h2 className="text-center mb-4">Talk to a Real Human</h2>
        <p className="text-center mb-4">
          Need help? Ask for a live demo or request a personalized setup.
        </p>
        <Row className="text-center">
          {[
            { number: '+254707615635', message: 'Hi, I would like to request a quotation and demo for your inventory system.' },
            { number: '+254711280760', message: 'Hello, I am interested in a live demo of your inventory management software.' },
            { number: '+254714726968', message: 'Greetings, can I get a quotation and walkthrough of the system?' },
            { number: '+254737526147', message: 'Greetings, can I get a quotation and walkthrough of the system?' },
          ].map(({ number, message }, index) => (
            <Col key={index} md={4} className="mb-3">
              <a
                href={`https://wa.me/${number.replace('+', '')}?text=${encodeURIComponent(message)}`}
                className="btn btn-success d-flex align-items-center justify-content-center"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaWhatsapp className="me-2" /> WhatsApp {number}
              </a>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Footer Section */}
      <footer className="bg-dark text-white py-5 mt-5">
        <Container className="text-center">
          <h5>You've Worked Too Hard to Stay in the Dark</h5>
          <p className="text-muted">Take the first step toward peace of mind and smarter decisions.</p>
          <Button variant="light" className="mt-3" as={Link} to="/auth">
            Begin Free Trial
          </Button>
          <hr className="my-4 border-light" />
          <p className="text-muted small mb-0">© 2024 FinTrack. All rights reserved.</p>
        </Container>
      </footer>
    </>
  );
};

const FeatureCard = ({ icon, title, description }) => (
  <Col md={3}>
    <Card className="h-100 shadow-sm border-0">
      <Card.Body>
        <div className="text-success mb-3">{icon}</div>
        <Card.Title>{title}</Card.Title>
        <Card.Text className="text-muted">{description}</Card.Text>
      </Card.Body>
    </Card>
  </Col>
);

const MetricCard = ({ title, value, icon, bg }) => (
  <Col md={6}>
    <Card className={`bg-${bg}-100 border-0 rounded shadow-sm p-3 mb-3`}>
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <div className="text-muted small">{title}</div>
          <div className="fs-4 fw-bold">{value}</div>
        </div>
        <div className={`fs-2 text-${bg}`}>{icon}</div>
      </div>
    </Card>
  </Col>
);

export default Homepage;
